import React from 'react';
import {
  TextField,
  Popover,
  ResourceItem,
  DisplayText,
  Button,
  Spinner,
  Link,
  TextStyle
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { KB_CONSTANTS } from '../../constants/kb-constants';

function CollectionTitle({
  title,
  arrow,
  depth,
  context,
  item,
  info,
  children,
  expandedItems,
  focusedItem,
  selectedItems,
  handleSelect,
  handleExpand,
  setExpandedItems,
  loadingItems
}) {
  const isSelected = selectedItems.includes(item.index);
  const isFocused = focusedItem === item.index;
  const isExpanded = expandedItems.includes(item.index);
  return (
    <div className="fx col w100 astart">
      <div
        className={`fx actr w100 cp br-5 pt10 pb10 pr10 ${
          depth > 0 ? `pl${depth * 20 + 10}` : 'pl10'
        } ${isSelected ? 'kb-collection-tree-selected-bg' : ''}`}
        onClick={() => {
          if (depth < KB_CONSTANTS.COLLECTION_TREE_DEPTH_OFFSET) {
            if (
              expandedItems.includes(item.index) &&
              selectedItems.includes(item.index)
            ) {
              setExpandedItems((prev) => prev.filter((i) => i !== item.index));
            } else {
              handleExpand(item);
            }
          }
          handleSelect([item.index]);
        }}
      >
        <div className="flex actr g10 w100 jspbtwn">
          <div className="fx actr g10 w90percent">
            <div className="fx actr">
              {isExpanded || (isSelected && !children) ? (
                <SVGIcon name="Folder" />
              ) : (
                <SVGIcon name="FolderClosed" />
              )}
            </div>
            <div className="ellipsis">
              <Link monochrome ellipsis>
                {title}
              </Link>
            </div>
          </div>
          {loadingItems?.includes(item.index) && (
            <div className="fx actr mbm-4">
              <Spinner size="small" />
            </div>
          )}
        </div>
      </div>

      <div isActive={isFocused} className="full-width full-height">
        {children}
      </div>
    </div>
  );
}

export default CollectionTitle;
